import { Layout } from 'src/components/Layout';

import SidebarContainer from './Sidebar/SidebarContainer';

const LayoutContainer: React.FunctionComponent = () => {
  return <Layout sidebar={SidebarContainer} />;
};

export default LayoutContainer;
